import { MessageCircle } from 'lucide-react';
import { whatsappLink } from '../../data/site';
import { trackWhatsAppClick, type WhatsAppSource } from '../../lib/analytics';

/**
 * Shown whenever the booking engine can't give us live info. We never fall back
 * to stale prices — we send the guest to WhatsApp instead.
 */
export function WhatsAppFallback({
  message,
  contextLabel,
  source = 'booking_fallback',
}: {
  message?: string;
  contextLabel?: string;
  source?: WhatsAppSource;
}) {
  const href = whatsappLink(
    contextLabel
      ? `Hi Flying Muse! I'd like to book the ${contextLabel}. Could you share availability and pricing?`
      : undefined,
  );
  return (
    <div className="py-10 text-center">
      <p className="mx-auto max-w-sm font-sans text-sm font-light leading-relaxed text-stone">
        {message ??
          "We can't load live availability and pricing right now. Message us on WhatsApp and we'll sort your booking out personally."}
      </p>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsAppClick(source, undefined, contextLabel)}
        className="btn btn-primary mt-6 inline-flex items-center gap-2"
      >
        <MessageCircle className="h-4 w-4" />
        Contact us on WhatsApp
      </a>
    </div>
  );
}
